import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
import $ from "jquery";

export const getSrcsetLargestSrc = (srcset) => {
  if (srcset === undefined) {
    return "";
  }

  srcset = srcset.split(", ");

  let largestIndex = 0,
    largestSize = 0;

  srcset.forEach((e, i) => {
    let currentSize = e.split(" ")[1];
    currentSize = parseInt(currentSize.substring(0, currentSize.length - 1));

    if (currentSize > largestSize) {
      largestSize = currentSize;
      largestIndex = i;
    }
  });

  return srcset[largestIndex].split(" ")[0];
};

export const openLightbox = function (items, index = 0) {
  const options = {
    bgOpacity: 0.9,
    fullscreenEl: false,
    history: false,
    index: index,
  };

  const gallery = new PhotoSwipe(
    $(".pswp")[0],
    PhotoSwipeUI_Default,
    items,
    options
  );

  gallery.listen("imageLoadComplete", (index, item) => {
    if (item.h < 1 || item.w < 1) {
      let img = new Image();
      img.onload = () => {
        item.w = img.width;
        item.h = img.height;
        gallery.invalidateCurrItems();
        gallery.updateSize(true);
      };
      img.src = item.src;
    }
  });

  gallery.init();
};

$(".wp-block-gallery:not(.open) a").removeAttr("href");
$(".wp-block-image:not(.open) a").removeAttr("href");

$(".wp-block-gallery:not(.open) img").on("click", function () {
  const $thisEl = $(this);
  const galleryEl = $thisEl.closest(".wp-block-gallery");
  const figures = $("figure", galleryEl);

  let items = [];

  figures.each(function (i) {
    const img = $("img", this);
    const hires = img.data("hires");
    let src;

    hires ? (src = hires) : (src = getSrcsetLargestSrc(img.attr("srcset")));

    if (src == "") {
      src = img.attr("src");
    }

    const item = {
      src: src,
      w: 0,
      h: 0,
    };

    const caption = $("figcaption", this);
    if (caption.length > 0) {
      item["title"] = caption.html();
    }

    items.push(item);
    $(this).data("data-pswp-uid", i + 1);
  });

  const index = $thisEl.closest("figure").data("data-pswp-uid") - 1;

  openLightbox(items, index);
});

$(".wp-block-image:not(.open) img").on("click", function () {
  const $thisEl = $(this);

  if ($thisEl.closest(".wp-block-gallery").length === 0) {
    let src = getSrcsetLargestSrc($thisEl.attr("srcset"));

    if (!src) {
      src = $thisEl.attr("src");
    }

    const item = {
      src: src,
      w: 0,
      h: 0,
    };

    const caption = $("figcaption", this.closest(".wp-block-image"));
    if (caption.length > 0) {
      item["title"] = caption.html();
    }

    openLightbox([item]);
  }
});
